import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'IaeType/List', method: 'GET', body: null, token: token })
}
